/**
 * Factories container
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { actions } from './slice';
import {
  factoriesSelector,
  factoriesCountSelector,
  factoriesLoadingSelector,
} from './selectors';
import { userSelector } from '../User/selectors';
import VendorFactories from '../../Components/VendorFactories/VendorFactories';
import promisifyActions from '../../Lib/Utils/promisify-actions';
import { currentUserSelector } from '../App/selectors';

/**
 * Properties to be provided to the bill payment component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  factories: factoriesSelector(state),
  count: factoriesCountSelector(state),
  loading: factoriesLoadingSelector(state),
  user: userSelector(state),
  currentUser: currentUserSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch bill payment actions
 */
const mapDispatchToProps = (dispatch) => ({
  getFactories: (params, userId) =>
    dispatch(actions.getAll({ userId, params })),
});

/**
 * Connects state to the Vendor Factories component
 *
 * @param {object} mapStateToProps data object to become props for the Factories component
 * @param {object} mapDispatchToProps Factories actions to be dispatched to reducer
 */
export default withRouter(
  connect(
    mapStateToProps,
    promisifyActions(mapDispatchToProps),
  )((props) => <VendorFactories {...props} />),
);
